export const CONSTANT =  {
    baseUrl: process.env.REACT_APP_BASE_URL ?? 'https://api-uat.sportbook.vn/api/',
    adminAsset: process.env.REACT_APP_ADMIN_ASSET_URL ?? 'https://admin-uat.sportbook.vn/storage/admin/',
    apiVersion: 'v1',
    limit: 20
}